// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sandbox.css */
:root {
    --primary: #1E4388;
    --secondary: #4A90E2;
    --background: #F8FAFC;
    --text: #2C3E50;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: system-ui, -apple-system, sans-serif;
  }
  body {
    background-color: var(--background);
    color: var(--text);
    line-height: 1.5;
  }
  .navbar {
    background: white;
    padding: 1rem 2rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--primary);
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .nav-links {
    display: flex;
    gap: 2rem;
  }
  .nav-links a {
    color: var(--primary);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s;
  }
  .nav-links a:hover {
    color: var(--secondary);
  }
  .hero {
    padding: 6rem 2rem;
    text-align: center;
    background: var(--primary);
    color: white;
  }
  .hero h1 {
    font-size: 3rem;
    margin-bottom: 1.5rem;
    font-weight: 800;
  }
  .hero p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.9;
  }
  .cta-button {
    background: white;
    color: var(--primary);
    padding: 0.75rem 2rem;
    border-radius: 9999px;
    text-decoration: none;
    font-weight: 600;
    display: inline-block;
    transition: transform 0.2s;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  .cta-button:hover {
    transform: scale(1.05);
    background: #f8f9fa;
  }
  .features {
    padding: 4rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
  }
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  .feature-card {
    background: white;
    padding: 2rem;
    border-radius: 1rem;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    transition: transform 0.2s;
  }
  .feature-card:hover {
    transform: translateY(-5px);
  }
  .feature-icon {
    background: var(--primary);
    color: white;
    width: 4rem;
    height: 4rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    font-size: 1.5rem;
  }
  .feature-card h3 {
    color: var(--primary);
    margin-bottom: 1rem;
  }`, "",{"version":3,"sources":["webpack://./src/views/admin/sandbox/sandbox.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,iDAAiD;EACnD;EACA;IACE,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;IAC1B,qCAAqC;EACvC;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB","sourcesContent":["/* sandbox.css */\n:root {\n    --primary: #1E4388;\n    --secondary: #4A90E2;\n    --background: #F8FAFC;\n    --text: #2C3E50;\n  }\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: system-ui, -apple-system, sans-serif;\n  }\n  body {\n    background-color: var(--background);\n    color: var(--text);\n    line-height: 1.5;\n  }\n  .navbar {\n    background: white;\n    padding: 1rem 2rem;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .logo {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: var(--primary);\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  .nav-links {\n    display: flex;\n    gap: 2rem;\n  }\n  .nav-links a {\n    color: var(--primary);\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s;\n  }\n  .nav-links a:hover {\n    color: var(--secondary);\n  }\n  .hero {\n    padding: 6rem 2rem;\n    text-align: center;\n    background: var(--primary);\n    color: white;\n  }\n  .hero h1 {\n    font-size: 3rem;\n    margin-bottom: 1.5rem;\n    font-weight: 800;\n  }\n  .hero p {\n    font-size: 1.25rem;\n    margin-bottom: 2rem;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n    opacity: 0.9;\n  }\n  .cta-button {\n    background: white;\n    color: var(--primary);\n    padding: 0.75rem 2rem;\n    border-radius: 9999px;\n    text-decoration: none;\n    font-weight: 600;\n    display: inline-block;\n    transition: transform 0.2s;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n  }\n  .cta-button:hover {\n    transform: scale(1.05);\n    background: #f8f9fa;\n  }\n  .features {\n    padding: 4rem 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  .features-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 2rem;\n    margin-top: 3rem;\n  }\n  .feature-card {\n    background: white;\n    padding: 2rem;\n    border-radius: 1rem;\n    text-align: center;\n    box-shadow: 0 4px 6px rgba(0,0,0,0.05);\n    transition: transform 0.2s;\n  }\n  .feature-card:hover {\n    transform: translateY(-5px);\n  }\n  .feature-icon {\n    background: var(--primary);\n    color: white;\n    width: 4rem;\n    height: 4rem;\n    border-radius: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1.5rem;\n    font-size: 1.5rem;\n  }\n  .feature-card h3 {\n    color: var(--primary);\n    margin-bottom: 1rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
